import React, { CSSProperties } from 'react';
import { Button, Stack, Text, ClipIcon, Element, merge } from '@quotient/riq-react-ui';
import { Interpolation } from '@emotion/react';

import styles from './styles';

interface IStateColors {
  bgActive?: string;
  bgInactive?: string;
  textColorActive?: string;
  textColorInActive?: string;
}

interface ICartCounterProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  count?: number;
  text?: string;
  cartIcon?: React.Component;
  colors?: IStateColors;
  css?: Interpolation<any>;
}

const defaultStateColors: IStateColors = {
  bgActive: 'primary',
  bgInactive: 'grays.400',
  textColorActive: 'primary',
  textColorInActive: 'white'
};

export const CartCounter: React.FC<ICartCounterProps> = ({
  count = 0,
  text = 'items',
  cartIcon = <ClipIcon />,
  colors,
  css,
  ...props
}) => {
  const stateColors: IStateColors = merge(defaultStateColors, colors);
  const isActive = count > 0;
  const textColor = isActive ? stateColors.textColorActive : stateColors.textColorInActive;

  return (
    <Button
      component="CartCounter"
      css={merge(
        styles.CartCounter,
        { backgroundColor: isActive ? stateColors.bgActive : stateColors.bgInactive, color: textColor },
        css
      )}
      {...props}
    >
      <Element as="span" css={{ display: ['none', 'block', 'block'], padding: '0px 8px' }}>
        {cartIcon}
      </Element>
      <Element
        as="span"
        css={{
          display: ['none', 'block', 'block'],
          border: '1px solid',
          borderColor: textColor,
          height: '26px'
        }}
      ></Element>
      <Stack
        as="span"
        css={{ lineHeight: 'initial', alignItems: 'center' }}
        direction={['vertical', 'horizontal', 'horizontal']}
      >
        <Text color={textColor} size="6" css={{ paddingX: '1' }}>
          {count}
        </Text>
        <Text color={textColor} size={[2, 4, 4]}>
          {text}
        </Text>
      </Stack>
    </Button>
  );
};
